import withDashboardLayout from '../../Layouts/AdminPanel'
import InteractionsDashboard from '../../components/InteractionsDashboard'

function Analytics() {
	return <InteractionsDashboard />
}

export default withDashboardLayout(Analytics)
